import { Game, useCheckGameCodeLazyQuery } from '../../gql-types';
import { History } from 'history';
import { ProfileContext } from '../../contexts/ProfileContext';
import { getGameCardConfiguration } from '../../configuration/gamesConfiguration';
import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ContentWrapper from '../../components/common/wrappers/ContentWrapper';
import FullPageLoading from '../../components/common/FullPageLoading';
import GameSelectCard from '../../components/common/game-select/GameSelectCard';
import PageWrapper from '../../components/common/wrappers/PageWrapper';

type LocationStateGameSelect = {
    gameCode: string;
    newDevice?: boolean;
};

type Props = History<LocationStateGameSelect> & {
    data?: {
        loading: boolean;
        game: Game | null;
        error: any;
    };
    location: Location;
    newDevice?: boolean;
};

export default function GameSelect(props: Props) {
    const { availableGame, loadAvailableGame } = useContext(ProfileContext);
    const [check, { loading, error, data }] = useCheckGameCodeLazyQuery();

    useEffect(() => {
        check({
            variables: {
                code: props.location?.state?.gameCode,
                token: availableGame?.token ?? null,
                newDevice: props.location?.state?.newDevice ?? false,
            },
            context: {
                fetchPolicy: 'network-only',
            },
        });
    }, []);

    const history = useHistory();

    useEffect(() => {
        if (error && error?.message === 'UNAUTHORIZED') {
            history.push({
                pathname: '/game-in-progress',
                state: { gameCode: props.location?.state?.gameCode },
            });
        } else if (error && error?.message.includes('CODE INVALID')) {
            history.push({
                pathname: '/code-invalid',
            });
        } else if (error) {
            history.push({
                pathname: '/error',
            });
        }
        if (data && data.game && data.game.used) {
            history.push({
                pathname: '/code-used',
            });
        }
        if (data && data.game) {
            const todayFirst = new Date();
            todayFirst.setHours(0);
            todayFirst.setMinutes(0);
            todayFirst.setSeconds(0);
            todayFirst.setMilliseconds(0);
            let current = Math.floor(todayFirst.getTime() / 1000);
            const validFrom = parseInt(data.game.validFrom || '0');
            const validTo = parseInt(data.game.validTo || '0');
            if (validFrom > current) {
                history.push({
                    pathname: '/code-not-valid-yet',
                });
            }
            todayFirst.setHours(23);
            todayFirst.setMinutes(59);
            todayFirst.setSeconds(59);
            todayFirst.setMilliseconds(999);
            current = Math.floor(todayFirst.getTime() / 1000);

            if (validTo < current) {
                history.push({
                    pathname: '/code-expired',
                });
            }
        }
        if (data && data.game === null && !error) {
            history.push({
                pathname: '/code-invalid',
            });
        }
        if (data && data.game !== null && data.game !== undefined && availableGame === null) {
            loadAvailableGame(data.game);
        }
    }, [availableGame, data, history, loadAvailableGame, error]);

    useEffect(() => {
        if (availableGame && availableGame.teamName !== null && !availableGame.used) {
            const { gameType } = availableGame;
            // @ts-expect-error
            const gameCardConfiguration = getGameCardConfiguration(gameType);
            if (gameCardConfiguration !== null) {
                history.push({
                    pathname: gameCardConfiguration.gameUrl,
                });
            }
        }
    }, [availableGame, history]);

    if (availableGame === null || loading) {
        return (
            <PageWrapper>
                <div className="game-screen">
                    <FullPageLoading />
                </div>
            </PageWrapper>
        );
    }

    if (availableGame) {
        if (
            availableGame.lastStep === null ||
            (availableGame.lastStep && availableGame.lastStep > 0) ||
            availableGame.teamName !== null
        ) {
            return (
                <PageWrapper>
                    <div className="game-screen">
                        <FullPageLoading />
                    </div>
                </PageWrapper>
            );
        }
    }

    return (
        <PageWrapper>
            <div className="game-screen">
                <ContentWrapper>{availableGame && <GameSelectCard />}</ContentWrapper>
            </div>
        </PageWrapper>
    );
}
